import Tab, {TabGroup} from "@amzn/meridian/tab";
import React, {useState} from "react";
import {matchPath, Route} from "react-router-dom";
import {FormattedMessage} from "react-intl";

/**
 * Custom hook that checks which route matches the current location
 * and returns its name in the object
 * @param routes
 * @param location
 * @returns Object
 */
const useCurrentRoute = (routes, location) => {
    const currentPath = location.pathname;
    const {name} = routes.find(route => !!(matchPath(currentPath, {
        path: route.path
    }))) || {};
    return {name: name};
}

/**
 * Returns Route components from a list of routes
 * @param routes
 * @returns JSX.Element
 */
export const NavigationRoutes = ({routes}) => {
    return (routes.map(({path, component}) => (<Route key={path} path={path} component={component}/>)))
}

/**
 * Component that handles the tab UI and changes
 * @param routes
 * @returns JSX.Element
 */
const TabLayout = (props) => {
    const [state, setState] = useState(useCurrentRoute(props.routes, props.location));
    const onTabChange = (selectedTab) => {
        props.routes.forEach(({name, path}) => {
            if (name === selectedTab) {
                setState({name: name});
                props.history.push(path);
            }
        })
    };
    return (<TabGroup value={state.name} onChange={onTabChange} fill="line">
        {props.routes.map(({name, id}) => (<Tab key={name} value={name}>
            <FormattedMessage id={id}/>
        </Tab>))}
    </TabGroup>)
}

export default TabLayout



// WEBPACK FOOTER //
// ./src/components/util/TabLayout.js